export default __webpack_public_path__ + "static/media/team_02.2214021b.png";